/*! @pentacode/ui v0.1.0 */
import { t as e } from "../../../styledElement-Dm1irIE2.js";
import { t } from "../../../decorateMetadata-BhwOl-pv.js";
import { t as n } from "../../../decorate-DHgd5sZx.js";
import { FormElement as r } from "../../formElement.js";
import "../../../checkbox-BOki-Nk5.js";
import "../../form-elements/select.js";
import "../../form-elements/text-input.js";
import { LitElement as i, html as a, nothing as o } from "lit";
import { customElement as s, property as c, state as l } from "lit/decorators.js";
//#region src/elements/employee-questionnaire/shared/current-status-section.ts
var u = [
	{
		label: "Arbeitnehmer:in mit Hauptbeschäftigung",
		value: "mainEmployment"
	},
	{
		label: "Unbezahlter Urlaub (Hauptbeschäftigung)",
		value: "unpaidLeave"
	},
	{
		label: "Elternzeit (Hauptbeschäftigung)",
		value: "parentalLeave"
	},
	{
		label: "Schüler:in",
		value: "pupil"
	},
	{
		label: "Student:in (Immatrikulationsbescheinigung)",
		value: "student"
	},
	{
		label: "Schulentlassener:in mit Berufsausbildungsabsicht",
		value: "schoolLeaverApprenticeship"
	},
	{
		label: "Schulentlassene:r mit Studienabsicht",
		value: "schoolLeaverStudy"
	},
	{
		label: "Schulentlassene:r mit Freiwilligendienstabsicht",
		value: "schoolLeaverVoluntary"
	},
	{
		label: "Arbeit-/Ausbildungssuchende:r",
		value: "jobSeeker"
	},
	{
		label: "Freiwilligendienstleistende:r",
		value: "voluntaryService"
	},
	{
		label: "Pflichtpraktikant:in",
		value: "mandatoryIntern"
	},
	{
		label: "Freiwillige:r Praktikant:in",
		value: "voluntaryIntern"
	},
	{
		label: "Beamte:r",
		value: "civilServant"
	},
	{
		label: "Selbstständig",
		value: "selfEmployed"
	},
	{
		label: "Altersvollrentner:in (vor Regelaltersgrenze)",
		value: "retireeBeforeAgeLimit"
	},
	{
		label: "Altersvollrentner:in (nach Regelaltersgrenze)",
		value: "retireeAfterAgeLimit"
	},
	{
		label: "Versorgungsempfänger:in (nach Altersgrenze)",
		value: "pensioner"
	},
	{
		label: "Sonstiges",
		value: "other"
	}
], d = class extends e(r(i)) {
	constructor(...e) {
		super(...e), this.data = {
			immatriculationStatus: !1,
			registeredAsJobSeeker: !1,
			receivingAgencyBenefits: !1
		}, this._immatriculationStatus = !1, this._currentStatus = "", this._otherStatus = "", this._registeredAsJobSeeker = !1, this._responsibleAgency = "", this._receivingAgencyBenefits = !1;
	}
	willUpdate(e) {
		e.has("data") && this.data && (this._immatriculationStatus = this.data.immatriculationStatus, this._currentStatus = this.data.currentStatus ?? "", this._otherStatus = this.data.otherStatus ?? "", this._registeredAsJobSeeker = this.data.registeredAsJobSeeker, this._responsibleAgency = this.data.responsibleAgency ?? "", this._receivingAgencyBenefits = this.data.receivingAgencyBenefits);
	}
	_handleSectionChange() {
		this._registeredAsJobSeeker || (this._responsibleAgency = ""), this._currentStatus !== "other" && (this._otherStatus = ""), this.dispatchEvent(new CustomEvent("change", {
			detail: {
				immatriculationStatus: this._immatriculationStatus,
				currentStatus: this._currentStatus || void 0,
				otherStatus: this._otherStatus || void 0,
				registeredAsJobSeeker: this._registeredAsJobSeeker,
				responsibleAgency: this._responsibleAgency || void 0,
				receivingAgencyBenefits: this._receivingAgencyBenefits
			},
			bubbles: !0,
			composed: !0
		}));
	}
	render() {
		return a`
            <section class="w-full">
                <h2 class="mb-4 px-2 text-xl font-semibold">Aktueller Status</h2>

                <div class="flex flex-col gap-4">
                    <div class="flex items-center gap-2 px-2">
                        <ptc-ui-checkbox
                            id="immatriculationStatus"
                            name="immatriculationStatus"
                            .checked=${this._immatriculationStatus}
                            @change=${(e) => {
			e.stopPropagation(), this._immatriculationStatus = e.detail.checked, this._handleSectionChange();
		}}
                        ></ptc-ui-checkbox>
                        <label for="immatriculationStatus" class="text-sm font-medium text-gray-700">
                            Sie sind derzeit immatrikuliert
                            <span class="block text-xs text-gray-500"
                                >Sie sind an einer Hochschule, Fachhochschule oder Universität eingeschrieben</span
                            >
                        </label>
                    </div>

                    <div class="flex gap-4">
                        <div class="flex-1">
                            <ptc-ui-select
                                .options=${u}
                                name="currentStatus"
                                label="Aktueller Status"
                                .value=${this._currentStatus}
                                @change=${(e) => {
			e.stopPropagation(), this._currentStatus = e.detail.value, this._handleSectionChange();
		}}
                            ></ptc-ui-select>
                        </div>

                        ${this._currentStatus === "other" ? a`
                                  <div class="flex-1">
                                      <ptc-ui-text-input
                                          name="otherStatus"
                                          label="Sonstiges"
                                          placeholder="Status eingeben"
                                          .value=${this._otherStatus}
                                          maxlength="200"
                                          required
                                          @change=${(e) => {
			e.stopPropagation(), this._otherStatus = e.detail.value, this._handleSectionChange();
		}}
                                      ></ptc-ui-text-input>
                                  </div>
                              ` : a`<div class="flex-1"></div>`}
                    </div>

                    <div class="flex items-center gap-2 px-2">
                        <ptc-ui-checkbox
                            id="registeredAsJobSeeker"
                            name="registeredAsJobSeeker"
                            .checked=${this._registeredAsJobSeeker}
                            @change=${(e) => {
			e.stopPropagation(), this._registeredAsJobSeeker = e.detail.checked, this._handleSectionChange();
		}}
                        ></ptc-ui-checkbox>
                        <label for="registeredAsJobSeeker" class="text-sm font-medium text-gray-700">
                            Arbeitssuchend
                            <span class="block text-xs text-gray-500"
                                >Sie sind zu Beginn des Beschäftigungsverhältnisses als arbeits- oder ausbildungssuchend
                                bei der Agentur für Arbeit gemeldet.</span
                            >
                        </label>
                    </div>

                    ${this._registeredAsJobSeeker ? a`
                              <div class="flex gap-4">
                                  <div class="flex-1">
                                      <ptc-ui-text-input
                                          name="responsibleAgency"
                                          label="Agentur für Arbeit in"
                                          placeholder="Ort der Agentur"
                                          .value=${this._responsibleAgency}
                                          maxlength="200"
                                          required
                                          @change=${(e) => {
			e.stopPropagation(), this._responsibleAgency = e.detail.value, this._handleSectionChange();
		}}
                                      ></ptc-ui-text-input>
                                  </div>
                                  <div class="flex-1"></div>
                              </div>

                              <div class="flex items-center gap-2 px-2">
                                  <ptc-ui-checkbox
                                      id="receivingAgencyBenefits"
                                      name="receivingAgencyBenefits"
                                      .checked=${this._receivingAgencyBenefits}
                                      @change=${(e) => {
			e.stopPropagation(), this._receivingAgencyBenefits = e.detail.checked, this._handleSectionChange();
		}}
                                  ></ptc-ui-checkbox>
                                  <label for="receivingAgencyBenefits" class="text-sm font-medium text-gray-700"
                                      >mit Leistungsbezug</label
                                  >
                              </div>
                          ` : o}
                </div>
            </section>
        `;
	}
};
n([c({ type: Object }), t("design:type", Object)], d.prototype, "data", void 0), n([l(), t("design:type", Object)], d.prototype, "_immatriculationStatus", void 0), n([l(), t("design:type", Object)], d.prototype, "_currentStatus", void 0), n([l(), t("design:type", Object)], d.prototype, "_otherStatus", void 0), n([l(), t("design:type", Object)], d.prototype, "_registeredAsJobSeeker", void 0), n([l(), t("design:type", Object)], d.prototype, "_responsibleAgency", void 0), n([l(), t("design:type", Object)], d.prototype, "_receivingAgencyBenefits", void 0), d = n([s("ptc-ui-employee-questionnaire-current-status-section")], d);
//#endregion
export { d as EmployeeQuestionnaireCurrentStatusSection };

//# sourceMappingURL=current-status-section.js.map